var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 6 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 .75v.5h3.395L.822 4.822l.356.356L4.75 1.605V5h.5V.75Z"
  })));
};
export default SvgArrowUpRight;